import { api } from "../api";
import { esc } from "../utils/html";

export async function render(el: HTMLElement) {
  el.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;height:200px"><div class="spinner"></div></div>`;

  try {
    const depts = await api.schuelerApp.fachbereiche();

    if (depts.length === 0) {
      el.innerHTML = `
        <div class="page-header"><h1>Fachbereiche</h1></div>
        <div class="empty-state"><p>Für deine Klasse sind keine Fachbereiche hinterlegt.</p></div>`;
      return;
    }

    el.innerHTML = `
      <div class="page-header">
        <h1>Fachbereiche</h1>
        <p style="color:#6b7280;margin:0">Übersicht deiner Ausbildungsfachbereiche und Pflichtstunden</p>
      </div>
      <div style="display:grid;gap:1rem;grid-template-columns:repeat(auto-fill,minmax(280px,1fr))">
        ${depts.map(d => {
          const targetHours = d.requiredHours + d.poolHours;
          const hoursLine = targetHours > 0
            ? `<div style="font-size:.875rem;color:#374151;margin-top:.5rem">
                 <span style="color:#6b7280">Pflichtstunden:</span>
                 <strong>${targetHours} Std.</strong>
               </div>`
            : `<div style="font-size:.8rem;color:#9ca3af;margin-top:.5rem">keine Pflichtangabe</div>`;

          return `<div class="card" style="padding:1.25rem;border-left:4px solid ${esc(d.color)}">
            <div style="display:flex;align-items:center;gap:.75rem">
              ${d.shortName ? `<div style="width:2.5rem;height:2.5rem;border-radius:6px;background:${esc(d.color)};display:flex;align-items:center;justify-content:center;font-weight:700;font-size:.8rem;color:#fff;flex-shrink:0">${esc(d.shortName)}</div>` : `<div style="width:2.5rem;height:2.5rem;border-radius:6px;background:${esc(d.color)};flex-shrink:0"></div>`}
              <div style="min-width:0">
                <div style="font-weight:600;font-size:1rem;color:#111827;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${esc(d.nameDe)}</div>
              </div>
            </div>
            ${hoursLine}
          </div>`;
        }).join("")}
      </div>`;
  } catch (err: any) {
    el.innerHTML = `<div class="alert alert-error">Fehler beim Laden: ${esc(err.message)}</div>`;
  }
}
